import {
  ExpectedProductRoles,
  waitForRolePropagation,
} from "@/utils/api/auth0RolePropagation";

export type RefreshProductAccessSessionParams = ExpectedProductRoles & {
  renewToken: () => Promise<void>;
};

export type RefreshProductAccessSessionResult = {
  verified: boolean;
};

/**
 * Soft-refresh the browser session after product-access roles change.
 * Polls Auth0 role assignment, then renews the session so `refreshAuthSeed`
 * can re-read Galactus seats. Used by self-edit UI and Ably-driven remote updates.
 */
export async function refreshProductAccessSession({
  shouldHave,
  shouldNotHave,
  renewToken,
}: RefreshProductAccessSessionParams): Promise<RefreshProductAccessSessionResult> {
  const { verified } = await waitForRolePropagation({
    shouldHave,
    shouldNotHave,
  });

  if (!verified) {
    console.warn(
      "Role propagation not verified, proceeding with product access session refresh anyway"
    );
  }

  await renewToken();
  return { verified };
}
